import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelEmpty } from '../../../../component/common/designSystem';

/**
 * What the section shows instead of numbers when the group is too small.
 *
 * A deliberate state, not an error and not an empty one, so it says so plainly.
 * "No data" would be a lie — there is data, and it is being withheld because
 * reporting it would identify people.
 *
 * The exact player count is not shown, and the backend does not send it. "4
 * people" in a department of six is most of the way to a name, even for
 * something as ordinary as a game of chess.
 */
const SuppressedPanel = ({ minimum, what = 'these games', className = '' }) => (
  <div className={className}>
    <Panel title="Not enough players to report" subtitle="Withheld to protect the people playing">
      <PanelEmpty>
        Fewer than {minimum} people in the current view have played {what}. Figures stay hidden
        until there are at least {minimum}, so nothing here can be traced back to an individual —
        with a handful of players, &ldquo;most levels were played at the weekend&rdquo; is one
        person&apos;s Saturday.
        <br />
        <br />
        Widening the department filter, or switching between employees and members, may bring enough
        people into view.
      </PanelEmpty>
    </Panel>
  </div>
);

SuppressedPanel.propTypes = {
  minimum: PropTypes.number,
  what: PropTypes.string,
  className: PropTypes.string
};

export default SuppressedPanel;
